import Setup from "./Setup.page";

export default Setup;
